// Функция для удаления старых подсветок
export function removeHighlights(element: HTMLElement) {
  const highlights = element.querySelectorAll("span.bg-yellow-300");
  highlights.forEach((span) => {
    const parent = span.parentNode;
    if (!parent) return;

    while (span.firstChild) {
      parent.insertBefore(span.firstChild, span);
    }

    parent.removeChild(span);
    parent.normalize(); // Объединяем текстовые узлы
  });
}

export function highlightSearchText(element: HTMLElement | null, text: string): void {
  if (!element || !text) return;

  // Убираем старые подсветки
  removeHighlights(element);

  const escapedText = text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedText, "gi");

  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];

  let currentNode = walker.nextNode() as Text | null;

  // Сначала собираем все текстовые ноды
  while (currentNode !== null) {
    if (currentNode.nodeValue && currentNode.nodeValue.trim() !== "") {
      textNodes.push(currentNode);
    }
    currentNode = walker.nextNode() as Text | null;
  }

  // Затем обрабатываем
  textNodes.forEach((node) => {
    const parent = node.parentElement;
    if (!parent) return;

    const matches = node.nodeValue?.match(regex);
    if (matches) {
      const newHtml = node.nodeValue!.replace(
        regex,
        (match) => `<span class="bg-yellow-300">${match}</span>`,
      );
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = newHtml;

      while (tempDiv.firstChild) {
        parent.insertBefore(tempDiv.firstChild, node);
      }

      parent.removeChild(node);
    }
  });
}
